import { API_ROUTES } from "./api_routes";
import { API_REQUESTS } from "./types";

const getDefaultApiLogMessages = (route) => {
  return {
    200: `[${route}]: Solicitud ejecutada con éxito`,
    500: `[${route}]: Ha ocurrido un error interno :( Comprueba que el servidor funciona de manera correcta`,
  };
};

export const API_LOG_MESSAGES = {
  [API_REQUESTS.CHECK_IF_CREDENTIALS_VALID]: {
    ...getDefaultApiLogMessages(API_ROUTES.CHECK_IF_CREDENTIALS_VALID),
    200: `[${API_ROUTES.CHECK_IF_CREDENTIALS_VALID}]: Credenciales de usuario válidas`,
    404: `[${API_ROUTES.CHECK_IF_CREDENTIALS_VALID}]: Las credenciales de usuario no son válidas.`,
  },
  [API_REQUESTS.CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP]: {
    ...getDefaultApiLogMessages(API_ROUTES.CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP),
    200: `[${API_ROUTES.CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP}]: La encuesta tiene un repositorio de applicants asociado.`,
    404: `[${API_ROUTES.CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP}]: La encuesta NO tiene un repositorio de applicants asociado.`,
  },
  [API_REQUESTS.CREATE_APPLICANT_SESSION]: {
    ...getDefaultApiLogMessages(API_ROUTES.CREATE_APPLICANT_SESSION),
    201: `[${API_ROUTES.CREATE_APPLICANT_SESSION}]: Los datos del applicant fueron ingresados con éxito a la base de datos.`,
    404: `[${API_ROUTES.CREATE_APPLICANT_SESSION}]: El identificador ingresado no se encontró en el repositorio de applicants.`,
  },
  [API_REQUESTS.CHECK_USER_ANSWERS_STATUS]: {
    ...getDefaultApiLogMessages(API_ROUTES.CHECK_USER_ANSWERS_STATUS),
    200: `[${API_ROUTES.CHECK_USER_ANSWERS_STATUS}]: El usuario ya había creado una sesión anteriormente pero no ha terminado la encuesta`,
    204: `[${API_ROUTES.CHECK_USER_ANSWERS_STATUS}]: El usuario ya había creado una sesión anteriormente, sin embargo ya completó la encuesta`,
    404: `[${API_ROUTES.CHECK_USER_ANSWERS_STATUS}]: El usuario no ha creado su sesión todavía, es la primera vez que entra a la encuesta`,
  },
  [API_REQUESTS.CREATE_NON_APPLICANT_SESSION]: {
    ...getDefaultApiLogMessages(API_ROUTES.CREATE_NON_APPLICANT_SESSION),
    200: `[${API_ROUTES.CREATE_NON_APPLICANT_SESSION}]: El usuario ya tiene una sesión de 'answers' en nuestros registros.`,
    201: `[${API_ROUTES.CREATE_NON_APPLICANT_SESSION}]: Sesión de 'answers' del usuario creada con exito!`,
  },
  [API_REQUESTS.GET_SPLASH_PAGE_BY_ROUTE]: {
    ...getDefaultApiLogMessages(API_ROUTES.GET_SPLASH_PAGE_BY_ROUTE),
    404: `[${API_ROUTES.GET_SPLASH_PAGE_BY_ROUTE}]: No se encontró el formulario en la base de datos.`,
  },
  [API_REQUESTS.GET_SURVEY_BY_ID]: {
    ...getDefaultApiLogMessages(API_ROUTES.GET_SURVEY_BY_ID),
  },
  [API_REQUESTS.CHECK_USER_ANSWERS]: {
    ...getDefaultApiLogMessages(API_ROUTES.CHECK_USER_ANSWERS),
  },
  [API_REQUESTS.SAVE_ANSWERS]: {
    ...getDefaultApiLogMessages(API_ROUTES.SAVE_ANSWERS),
    201: `[${API_ROUTES.SAVE_ANSWERS}]: Respuestas enviadas con éxito`,
  },
  [API_REQUESTS.FINISH_SURVEY]: {
    ...getDefaultApiLogMessages(API_ROUTES.FINISH_SURVEY),
    200: `[${API_ROUTES.FINISH_SURVEY}]: El formulario del usuario se ha finalizado con exito`,
  },
};
